import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, ApolloLink } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { NgModule } from '@angular/core';
import { environment } from './../environments/environment';

const uri = environment.graphql_api;

export function createApollo(httpLink: HttpLink) {
  const http = httpLink.create({uri});

  return {
    cache: new InMemoryCache(),
    link: ApolloLink.from([errorLink, http]),
  };
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  // if (networkError) console.log(`[Network error]: ${networkError}`);
});

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
